import React, { useEffect } from "react"
import parse from "html-react-parser"
import * as S from "./how-we-help.styles"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const HowWeHelp = ({
  backgroundPattern,
  topTitle,
  title,
  features,
  progressImage,
}) => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    gsap.defaults({ ease: "none" })
    const pulses = gsap
      .timeline({
        defaults: {
          autoAlpha: 1,
          visibility: "visible",
          ease: "elastic(2.5, 1)",
        },
      })
      .to("#first", {}, 0)
      .to("#second", {}, 0.72)
      .to("#third", {}, 1.45)

    const main = gsap
      .timeline({
        scrollTrigger: {
          trigger: "#wrapper",
          scrub: true,
          start: "top center",
        },
      })
      .fromTo(
        "#line",
        { delay: 0.3, attr: { d: "M18 39L18 5" } },
        { attr: { d: "M18 39L18 990" }, duration: 1.5 },
        0,
      )
      .add(pulses, 0)
  }, [])
  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <S.InfoContainer>
          <S.Pattern img={backgroundPattern}>
            <S.ContentContainer>
              <S.TitleContainer>
                <S.TopTitle>{topTitle}</S.TopTitle>
                <S.Title>{title}</S.Title>
              </S.TitleContainer>
              <S.FeaturesWrapper id="wrapper">
                <S.ProgressImage />
                {features?.map(({ image, description }, index) => (
                  <S.FeatureContainer
                    key={`${index}-${description}`}
                    className={index === 1 ? "right" : ""}
                  >
                    <S.CardContainer className={index === 1 ? "right" : ""}>
                      <S.Image img={image} />
                      <S.Description>{parse(description)}</S.Description>
                    </S.CardContainer>
                  </S.FeatureContainer>
                ))}
              </S.FeaturesWrapper>
            </S.ContentContainer>
          </S.Pattern>
        </S.InfoContainer>
      </S.Wrapper>
    </S.Section>
  )
}

export default HowWeHelp
